export default __webpack_public_path__ + "static/height-cb571ec4d3553d5f2198e28bfa4f24c5.png";